export const THEWEST_ALL = 'thewest:all' // can read premium articles
export const THEWEST_REGISTERED = 'thewest:registered' // has an account, but no extra features
export const THEWEST_REPLICA = 'thewest:replica' // can read the digital edition
export const THEWEST_COMMENTS = 'thewest:comments' // can put comments
export const THEWEST_PREMIUM = 'thewest:premium' // can only access premium articles
export const WESTBENEFITS = 'westbenefits'
export const WESTREWARDS = 'westrewards'
